import validate from "/app/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typescrip_rxw35gvteffnpeq5d2mjl5gli4/node_modules/nuxt/dist/pages/runtime/validate.js";
import check_45access_45global from "/app/app/middleware/check-access.global.ts";
import dashboard_45auth_45global from "/app/app/middleware/dashboard-auth.global.ts";
import dashboard_45redirect_45global from "/app/app/middleware/dashboard-redirect.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@4.5.2_@babel+plugin-syntax-jsx@7.28.6_@babel+core@7.29.0__@babel+plugin-syntax-typescrip_rxw35gvteffnpeq5d2mjl5gli4/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  check_45access_45global,
  dashboard_45auth_45global,
  dashboard_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/app/app/middleware/auth.ts"),
  "server-access": () => import("/app/app/middleware/server-access.ts")
}